import { fetchPost, fetchPut, fetchGet, fetchDelete } from '@/utils/request'

export function getSiteByIds (idStr) {
    let query = {
        site_ids : idStr
    }
    return fetchGet('/gateway/v1/sites-ids', query)
}

export function getSite (query) {
    return fetchGet('/gateway/v1/sites', query)
}

export function getSiteAll (query) {
    return fetchGet('/gateway/v1/sites/all', query)
}

export function getCities (query) {
    return fetchGet('/gateway/v1/cities', query)
}
export function getCityCode (query) {
    return fetchGet('/gateway/v1/cities/code',query)
}
export function getCityDetail (id) {
    return fetchGet('/gateway/v1/cities/'+id)
}
export function createSite (query) {
    return fetchPost('/gateway/v1/sites', query)
}

export function editSite (id, query) {
    return fetchPut('/gateway/v1/sites/'+id, query)
}
export function getSiteDetail (id) {
    return fetchGet('/gateway/v1/sites/'+id)
}
export function getPinyin (query) {
    return fetchGet('/gateway/v1/sites/pinyin', query)
}
export function getRepeat (query) {
    return fetchGet('/gateway/v1/sites/check', query)
}
export function bindCustomerHotlines (query) {
    return fetchPost('/gateway/v1/sites/bind-customer-hotlines', query)
}


export function getSiteAreas (query) {
    return fetchGet('/gateway/v1/site-areas', query)
}

export function getSiteAreasBySiteId (siteId) {
    return fetchGet('/gateway/v1/sites/'+ siteId + '/site-areas')
}

export function editSiteStatus (siteId,query) {
    return fetchPut('/gateway/v1/sites/'+ siteId + '/status',query)
}

export function createSiteAreas (query) {
    return fetchPost('/gateway/v1/site-areas', query)
}

export function editSiteAreas (id,query) {
    return fetchPut('/gateway/v1/site-areas/'+id, query)
}

export function deleteSiteAreas (id,query) {
    return fetchDelete('/gateway/v1/site-areas/'+id, query)
}

export function sortSiteAreas (id,query) {
    return fetchPut('/gateway/v1/site-areas/'+id+'/sort', query)
}


export function getSubways (siteId, query) {
    return fetchGet('/gateway/v1/sites/'+siteId+'/site-subways', query)
}

export function createSubways (siteId, query) {
    return fetchPost('/gateway/v1/sites/'+siteId+'/site-subways', query)
}

export function editSubways (siteId, id, query) {
    return fetchPut('/gateway/v1/sites/'+siteId+'/site-subways/' + id, query)
}

export function deleteSubways (siteId,id,query) {
    return fetchDelete('/gateway/v1/sites/'+siteId+'/site-subways/' + id, query)
}

export function sortSubways (siteId,id,query) {
    return fetchPut('/gateway/v1/sites/'+siteId+'/site-subways/' + id + '/sort', query)
}

export function getSubwayStations (subwayId, query) {
    return fetchGet('/gateway/v1/subways/'+subwayId+'/site-subways-station', query)
}

export function createSubwayStations (subwayId, query) {
    return fetchPost('/gateway/v1/subways/'+subwayId+'/site-subways-station', query)
}

export function editSubwayStations (subwayId, id, query) {
    return fetchPut('/gateway/v1/subways/'+subwayId+'/site-subways-station/' + id, query)
}

export function deleteSubwayStations (subwayId,id,query) {
    return fetchDelete('/gateway/v1/subways/'+subwayId+'/site-subways-station/' + id, query)
}

export function sortSubwayStations (subwayId,id,query) {
    return fetchPut('/gateway/v1/subways/'+subwayId+'/site-subways-station/' + id + '/sort', query)
}

export function getSitesAutoComplete(query) {
    return fetchGet('/gateway/v1/sites-auto-complete', query)
}
export function siteAreasSync(query) { //站点区域同步
    return fetchPost('/gateway/v1/site-areas/synchronization', query)
}

export function getSitesFileList(query) { //获取站点验证文件列表
    return fetchGet('/gateway/v1/site-verify-files', query)
}
export function uploadSitesFile(query) { //创建站点验证文件
    return fetchPost('/gateway/v1/site-verify-files', query)
}
export function editSitesFile(id,query) { //编辑站点验证文件
    return fetchPut('/gateway/v1/site-verify-files/'+id, query)
}
export function deleteSitesFile(id) { //删除站点验证文件
    return fetchDelete('/gateway/v1/site-verify-files/'+id)
}
export function uploadVerify(code,query) { //上传站点验证文件
    return fetchPost('/gateway/v1/tos/'+code+'/site-verify-files',query)
}

export function getStatisCodes (params) { //站点统计代码列表
    return fetchGet('/gateway/v1/sites/statistical-codes', params)
}
export function editStatisCodes(id,query) { //站点统计代码修改内容
    return fetchPut('/gateway/v1/sites/statistical-codes/'+id, query)
}
export function editStatisCodeStatus(id,query) { //站点统计代码修改状态
    return fetchPut('/gateway/v1/sites/statistical-codes/'+id+'/status', query)
}

export function getSiteSet(id) { //查询站点配置详情
    return fetchGet('/gateway/v1/sites/'+id+'/site-set')
}
